import React from 'react';
import { JRCMainColumnProps } from './template.type';
import { MainColumn } from './template.styles';

export function JRCMainColumn({ children, ...props }: JRCMainColumnProps) {
    return <MainColumn {...props}>{children}</MainColumn>;
}
